export const en = {
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    loading: 'Loading...',
    noData: 'No data found',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    total: 'Total',
    date: 'Date',
    today: 'Today',
    month: 'Month',
    year: 'Year',
    week: 'Week',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    from: 'From',
    to: 'To',
    amount: 'Amount',
    quantity: 'Quantity',
    unit: 'Unit',
    price: 'Price',
    unitPrice: 'Unit Price',
    totalAmount: 'Total Amount',
    description: 'Description',
    category: 'Category',
    status: 'Status',
    actions: 'Actions',
    notes: 'Notes',
    supplier: 'Supplier',
    product: 'Product',
    name: 'Name',
    type: 'Type',
    dateRange: 'Date Range',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
  },

  // Navigation / Menu
  nav: {
    home: 'Dashboard',
    products: 'Products',
    stockOperations: 'Stock Operations',
    stockReport: 'Stock Report',
    prepKitchen: 'Prep Kitchen',
    transfer: 'Transfer',
    transferInvoice: 'Transfer Invoice',
    transferCost: 'Transfer Cost',
    paymentReport: 'Payment Report',
    checkManagement: 'Check Management',
    loanManagement: 'Loan Management',
    expenses: 'Expenses',
    vegetables: 'Vegetables/Grocery',
    meat: 'Meat/Poultry',
    generalProducts: 'General Products',
    profitLoss: 'Profit/Loss',
    recipes: 'Recipes',
    staff: 'Staff',
    suppliers: 'Suppliers',
    users: 'Users',
    settings: 'Settings',
    logout: 'Logout',
    inventoryCount: 'Inventory Count',
    orderSuggestion: 'Order Suggestion',
    sales: 'Sales',
    staffMeals: 'Staff Meals',
    mealPlanning: 'Meal Planning',
    smartMenu: 'Smart Menu',
    reports: 'Reports',
  },

  // Login Page
  auth: {
    welcome: 'Welcome',
    loginSubtitle: 'Sign in to restaurant stock management system',
    email: 'Email Address',
    password: 'Password',
    login: 'Login',
    register: 'Register',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    forgotPassword: 'Forgot Password',
    rememberMe: 'Remember Me',
    loginError: 'Login failed',
    loginSuccess: 'Login successful',
    logoutSuccess: 'Logged out',
    serverWaking: 'Server is starting, please wait...',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    subtitle: 'View your restaurant\'s current status',
    totalStockValue: 'Total Stock Value',
    todayNetProfit: 'Today\'s Net Profit',
    lowStock: 'Low Stock',
    monthNetProfit: 'This Month Net Profit',
    criticalLevel: 'Product at critical level',
    expense: 'Expense',
    profitLossChart: 'Profit/Loss Chart',
    mostUsed: 'Most Used',
    noDataYet: 'No data yet',
    products: 'products',
    grossRevenue: 'Gross',
    sales: 'sales',
    loss: 'Loss',
    profit: 'Profit',
  },

  // Products
  products: {
    title: 'Products',
    subtitle: 'Product definitions and stock status',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    productName: 'Product Name',
    productCode: 'Product Code',
    warehouseStock: 'Warehouse Stock',
    storeStock: 'Store Stock',
    minStock: 'Minimum Stock',
    maxStock: 'Maximum Stock',
    criticalStock: 'Critical Stock',
    lastPurchaseDate: 'Last Purchase Date',
    packageInfo: 'Package Info',
    packageQuantity: 'Package Quantity',
    packagePrice: 'Package Price',
    firePercentage: 'Waste Percentage',
  },

  // Stock Operations
  stockOperations: {
    title: 'Stock Operations',
    subtitle: 'Stock entry and exit operations',
    entry: 'Entry',
    exit: 'Exit',
    transfer: 'Transfer',
    adjustment: 'Adjustment',
    warehouse: 'Warehouse',
    store: 'Store',
    fromWarehouse: 'From Warehouse',
    toStore: 'To Store',
  },

  // Expenses
  expenses: {
    title: 'Expenses',
    subtitle: 'Manage business expenses',
    addExpense: 'Add Expense',
    editExpense: 'Edit Expense',
    monthlyTotal: 'Monthly Total',
    untilDate: 'until',
    fixedExpenses: 'Fixed Expenses',
    dailyExpenses: 'Daily Expenses',
    expenseCount: 'Expense Count',
    dailyTotal: 'Daily Total',
    dailyExpense: 'Daily Expense',
    fixedExpenseDaily: 'Fixed Expense (Daily)',
    fixed: 'Fixed',
    daily: 'Daily',
    applyTemplates: 'Apply Templates',
    transferSalaries: 'Transfer Salaries',
    gasInvoice: 'Gas Invoice',
    paymentType: 'Payment Type',
    cash: 'Cash',
    creditCard: 'Credit Card',
    bankTransfer: 'Bank Transfer',
    check: 'Check',
    dailyEffect: 'Daily Effect',
    perMonth: '/month',
    // Categories
    categories: {
      rent: 'Rent',
      electricity: 'Electricity',
      water: 'Water',
      gas: 'Gas/Coal',
      internet: 'Internet',
      phone: 'Phone',
      insurance: 'Social Security/Insurance',
      salary: 'Staff Salaries',
      fuel: 'Fuel',
      maintenance: 'Maintenance/Repair',
      cleaning: 'Cleaning',
      marketing: 'Marketing',
      courier: 'Courier/Delivery',
      extraStaff: 'Extra Staff',
      flour: 'Flour',
      cylinder: 'Gas Cylinder',
      other: 'Other',
    },
  },

  // Vegetables
  vegetables: {
    title: 'Vegetables/Grocery',
    subtitle: 'Manage vegetable and fruit purchases',
    addEntry: 'Add Vegetable/Grocery',
    importPdf: 'Import from PDF',
    totalSpending: 'Total Spending',
    records: 'records',
    bySupplier: 'By Supplier',
    byProduct: 'By Product',
  },

  // Meat
  meat: {
    title: 'Meat/Poultry Tracking',
    subtitle: 'Meat, poultry and fish purchases, carcass processing',
    addEntry: 'Add Meat/Poultry',
    importPdf: 'Import from PDF',
    totalSpending: 'Total Spending',
    entryList: 'Entry List',
    prepKitchen: 'Prep Kitchen',
    reports: 'Reports',
    carcass: 'Carcass',
    portioned: 'Portioned',
    processed: 'Processed',
    categories: {
      chicken: 'Chicken',
      beef: 'Beef',
      lamb: 'Lamb',
      fish: 'Fish',
      offal: 'Offal',
    },
  },

  // Prep Kitchen
  prepKitchen: {
    title: 'Prep Kitchen',
    subtitle: 'Carcass meat and poultry processing',
    newTemplate: 'New Template',
    templates: 'Templates',
    history: 'Processing History',
    totalProcessed: 'Total Processed',
    totalOutput: 'Total Output',
    totalWaste: 'Total Waste',
    wasteCost: 'Waste Cost',
    avgWaste: 'Avg.',
    queue: 'Prep Kitchen Queue',
    pending: 'Pending',
    processedItems: 'Processed',
    process: 'Process',
    rawMaterial: 'Raw Material',
    outputs: 'Outputs',
    waste: 'Waste',
  },

  // Transfer
  transfer: {
    title: 'Transfer',
    subtitle: 'Product transfer from warehouse to store',
    newTransfer: 'New Transfer',
    transferDate: 'Transfer Date',
    transferList: 'Transfer List',
    pendingTransfers: 'Pending Transfers',
    completedTransfers: 'Completed Transfers',
    fromWarehouse: 'From Warehouse',
    toStore: 'To Store',
    approve: 'Approve',
    reject: 'Reject',
  },

  // Transfer Cost
  transferCost: {
    title: 'Transfer Cost',
    subtitle: 'Cost of products transferred to store',
    totalCost: 'Total Cost',
    totalTransfers: 'Total Transfers',
    avgCostPerTransfer: 'Average Cost',
    dailySummary: 'Daily Summary',
    byCategorySummary: 'Category Summary',
  },

  // Profit/Loss
  profitLoss: {
    title: 'Profit/Loss Report',
    subtitle: 'Daily and monthly profit loss analysis',
    expenseDistribution: 'Expense Distribution',
    costSummary: 'Cost Summary',
    dailyDetail: 'Daily Detail',
    weeklySummary: 'Weekly Summary',
    revenueEntries: 'Revenue Entries',
    addDailyRevenue: 'Add Daily Revenue',
    addMonthlyRevenue: 'Add Monthly Revenue',
    totalRevenue: 'Total Revenue',
    totalCost: 'Total Cost',
    netProfit: 'Net Profit',
    profitMargin: 'Profit Margin',
    avgDailyRevenue: 'Avg. Daily Revenue',
    avgDailyCost: 'Avg. Daily Cost',
    avgDailyProfit: 'Avg. Daily Profit',
    revenue: 'Revenue',
    cost: 'Cost',
    profit: 'Profit',
    loss: 'Loss',
    // Cost categories
    generalExpenses: 'General Expenses',
    vegetablesCost: 'Vegetables/Grocery',
    meatCost: 'Meat/Poultry',
    staffSalaries: 'Staff Salaries',
    generalProductsCost: 'General Products',
    transferCost: 'Transfer Cost',
    checksDue: 'Checks Due',
  },

  // General Products
  generalProducts: {
    title: 'General Products',
    subtitle: 'Cleaning, beverages, packaging and other products',
    addEntry: 'Add Product Entry',
    importPdf: 'Import from PDF',
    categories: {
      cleaning: 'Cleaning',
      beverage: 'Beverage',
      packaging: 'Packaging',
      kitchen: 'Kitchen Equipment',
      office: 'Office/Stationery',
      other: 'Other',
    },
  },

  // Check Management
  checks: {
    title: 'Check Management',
    subtitle: 'Manage received and given checks',
    addCheck: 'Add Check',
    receivedChecks: 'Received Checks',
    givenChecks: 'Given Checks',
    checkNo: 'Check No',
    bank: 'Bank',
    dueDate: 'Due Date',
    collected: 'Collected',
    paid: 'Paid',
    pending: 'Pending',
    overdue: 'Overdue',
  },

  // Loan Management
  loans: {
    title: 'Loan Management',
    subtitle: 'Investment loans and payments',
    addLoan: 'Add Loan',
    addPayment: 'Add Payment',
    loanAmount: 'Loan Amount',
    remainingAmount: 'Remaining Amount',
    paidAmount: 'Paid Amount',
    interestRate: 'Interest Rate',
    startDate: 'Start Date',
    endDate: 'End Date',
    installment: 'Installment',
    payments: 'Payments',
    currency: 'Currency',
    exchangeRate: 'Exchange Rate',
  },

  // Staff
  staff: {
    title: 'Staff Management',
    subtitle: 'Employee information and salaries',
    addStaff: 'Add Staff',
    name: 'Full Name',
    position: 'Position',
    salary: 'Salary',
    startDate: 'Start Date',
    phone: 'Phone',
    active: 'Active',
    inactive: 'Inactive',
  },

  // Recipes
  recipes: {
    title: 'Recipes',
    subtitle: 'Product recipes and costs',
    addRecipe: 'Add Recipe',
    recipeName: 'Recipe Name',
    ingredients: 'Ingredients',
    portion: 'Portion',
    cost: 'Cost',
    sellingPrice: 'Selling Price',
    profitMargin: 'Profit Margin',
  },

  // Language
  language: {
    title: 'Language',
    turkish: 'Türkçe',
    english: 'English',
    selectLanguage: 'Select Language',
  },

  // Months
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },

  // Days
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },

  // Messages
  messages: {
    saveSuccess: 'Saved successfully',
    saveError: 'Error while saving',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Error while deleting',
    deleteConfirm: 'Are you sure you want to delete this record?',
    loadError: 'Error loading data',
    requiredField: 'This field is required',
    invalidEmail: 'Enter a valid email address',
    invalidNumber: 'Enter a valid number',
    noChanges: 'No changes made',
    unsavedChanges: 'You have unsaved changes',
  },
};
